<template>
  <v-container fluid>
    <Title :title="'Coupons'" />
    <v-row align="center" justify="center">
      <v-col cols="11">
        <v-tabs v-model="activeTab">
          <v-tab v-for="(tab, index) in tabs" :key="index">{{
            tab.text
          }}</v-tab>
        </v-tabs>
        <v-list dense v-if="couponType !== 'autogenerate'">
          <v-list-item
            v-for="(coupon, index) in coupons"
            :key="index"
            link
            :style="{ background: index % 2 == 0 ? '#efefef' : 'inherit' }"
          >
            <v-list-item-action>
              <v-btn icon @click="copyToClipboard(coupon.code, coupon.sum)">
                <v-icon>{{ "receipt" }}</v-icon>
              </v-btn>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                >{{ coupon.code }} : ${{ coupon.sum }}
                {{
                  coupon.terminal ? ` | ${coupon.terminal.name}` : ""
                }}</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-action>
              <div class="d-flex flex-row justify-end align-center">
                <v-btn
                  v-if="coupon.terminal"
                  icon
                  @click="
                    (coupon.enabled = !coupon.enabled), toggleCoupon(coupon._id)
                  "
                >
                  <v-icon :color="coupon.enabled ? 'green' : 'error'">{{
                    coupon.enabled ? "toggle_on" : "toggle_off"
                  }}</v-icon>
                </v-btn>
                <v-btn icon @click="deleteCoupon(coupon._id)">
                  <v-icon>{{ "delete" }}</v-icon>
                </v-btn>
              </div>
            </v-list-item-action>
          </v-list-item>
          <v-list-item v-if="coupons.length == 0" style="background: #efefef">
            <v-list-item-content>
              <v-list-item-title align="center">No coupons</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-dialog
          v-model="dialog"
          max-width="400"
          v-if="couponType !== 'autogenerate'"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mt-5"
              width="100%"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              Generate new
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="headline">New coupon</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-container class="mt-2">
                <v-form ref="form">
                  <v-text-field
                    v-model="coupon.sum"
                    label="Coupon amount"
                    type="number"
                    outlined
                    dense
                    :rules="[(v) => !!v || 'Coupon amount is required']"
                  ></v-text-field>
                  <v-select
                    v-if="activeTab == 1"
                    label="Choose terminal"
                    v-model="coupon.terminal_id"
                    dense
                    outlined
                    :items="terminals"
                    item-text="name"
                    item-value="id"
                    :rules="[(v) => !!v || 'Terminal name is required']"
                  ></v-select>
                  <v-text-field
                    v-model="coupon.text"
                    label="Coupon name"
                    type="text"
                    outlined
                    dense
                  ></v-text-field>
                </v-form>
              </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="$refs.form.reset, (dialog = false)"
                class="mr-4"
                >Close</v-btn
              >
              <v-btn color="primary" @click="generateCoupon()" class="mr-2">
                Create
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialog2"
          max-width="400"
          v-if="couponType == 'autogenerate'"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mt-5"
              width="100%"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              Generate coupons
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="headline">Coupon generator</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-container class="mt-2">
                <v-form ref="form">
                  <v-text-field
                    v-model="coupon.count"
                    label="Number of coupons"
                    type="text"
                    outlined
                    :rules="[(v) => !!v || 'Number of coupons is required']"
                    dense
                  ></v-text-field>
                  <v-select
                    v-model="coupon.type"
                    label="Choose type"
                    type="text"
                    outlined
                    :items="['Excel']"
                    :rules="[(v) => !!v || 'Type is required']"
                    dense
                  ></v-select>
                </v-form>
              </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="$refs.form.reset, (dialog2 = false)"
                class="mr-4"
                >Close</v-btn
              >
              <v-btn
                color="primary"
                @click="getAutogenerateExcel()"
                class="mr-2"
                :loading="excelInProgress"
              >
                Download
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :timeout="3000">
      Copied to clipboard
    </v-snackbar>
  </v-container>
</template>

<script>
import Title from "../components/Title.vue";

import {mapState} from "vuex";

export default {
  name: "Coupon",
  components: {
    Title,
  },
  data: () => ({
    coupons: [],
    dialog: false,
    dialog2: false,
    excelInProgress: false,
    coupon: {
      sum: "",
      terminal_id: "",
      text: "",
      count: 10,
      type: "Excel",
    },
    snackbar: false,
    tabs: [
      {
        type: "admin",
        text: "Manually created",
      },
      {
        type: "static",
        text: "Kiosk",
      },
      {
        type: "autogenerate",
        text: "Autogeneration",
      },
    ],
    activeTab: 0,
  }),
  computed: {
    couponType() {
      return this.tabs[this.activeTab].type;
    },
    ...mapState('terminals', ["terminals"]),
  },
  watch: {
    activeTab() {
      this.getCoupons();
    },
  },
  methods: {
    getCoupons() {
      this.$http
        .get("rest/coupon?type=" + this.couponType)
        .then((res) => {
          this.coupons = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteCoupon(id) {
      this.$http
        .delete("rest/coupon/" + id)
        .then(() => {
          this.getCoupons();
        })
        .catch(() => {
          this.getCoupons();
        });
    },
    toggleCoupon(id) {
      this.$http
        .put("/rest/coupon/toggle/" + id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return err;
        });
    },
    copyToClipboard(coupon, sum) {
      const el = document.createElement("textarea");
      el.value = `$${sum} coupon: ${coupon}`;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.snackbar = true;
    },
    generateCoupon() {
      if (this.$refs.form.validate()) {
        this.$http
          .post("/rest/coupon", this.coupon)
          .then(() => {
            this.$refs.form.reset();
            this.dialog = false;
            this.getCoupons();
          })
          .catch(() => {
            this.getCoupons();
          });
      }
    },
    async getAutogenerateExcel() {
      try {
        this.excelInProgress = true;

        var link = document.createElement("a");
        link.href = `https://api.gomagby.com/rest/coupon/generate?count=${
          this.coupon.count
        }&type=${this.coupon.type.toLowerCase()}`;

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
      } catch (err) {
        return err;
      } finally {
        this.dialog2 = false;
        this.excelInProgress = false;
      }
    },
  },
  mounted() {
    this.getCoupons();
  },
};
</script>
